/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as moment from 'moment';

export function validityCalculation(coupon: any): void {
  coupon.validity = coupon.validationWarnings && coupon.validationWarnings.length === 0
    && moment(coupon.validFrom).isBefore(moment())
    && moment(coupon.validTo).isAfter(moment()) ? 'Valid' : 'Invalid';
}

export function parseExpiryFields(model: any): void {
  if (!model.expiry) {
    model.expiryUnit = 'Days';
    return;
  }
  const inDays = moment.duration(model.expiry).asDays();
  const inMonths = moment.duration(model.expiry).asMonths();
  const inYears = moment.duration(model.expiry).asYears();

  if (inMonths % 1 === 0 && model.expiry.indexOf('M') === model.expiry.length - 1) {
    model.expiryNumber = inMonths;
    model.expiryUnit = 'Months';
  } else if (inYears % 1 === 0 && model.expiry.indexOf('Y') === model.expiry.length - 1) {
    model.expiryNumber = inYears;
    model.expiryUnit = 'Years';
  } else {
    model.expiryNumber = inDays;
    model.expiryUnit = 'Days';
  }
}
